import React, { useState } from "react";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomMenuIcon from "../../../../app/assets/custom-icons/CustomMenuIcon";
import CustomArrowIcon from "../../../../app/assets/custom-icons/CustomArrowIcon";
import CoreIAicon from "../../../../app/core/components/CoreIAicon/CoreIAicon";

const drawerWidth = 270;
const closedDrawerWidth = 65;

const CustomDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  zIndex: theme.zIndex.drawer + 2, // Ensure the Drawer appears above the AppBar
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    width: closedDrawerWidth, // Use the stored width for closed state
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    "& .MuiDrawer-paper": {
      width: closedDrawerWidth, // Use the stored width for closed state
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
  }),
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const Sidebar = ({ routes, open, setOpen, DrawerHeader, role }) => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const location = useLocation();
  const studio = useSelector((state) => state.app);

  const [selectedRoute, setSelectedRoute] = useState(
    location.pathname.split("/").pop()
  );
  const navigate = useNavigate();

  const returnLogoStudio = () => {
    let checkImage = studio.logoImageURL && studio.logoImageURL !== "";

    if (checkImage) {
      return (
        <div
          className={`bg-background w-full flex flex-row items-center ${
            open ? "justify-end" : "justify-center"
          }`}
        >
          {open ? (
            <div className="flex flex-row w-full items-center justify-between py-4 px-2">
              <div className="h-16 flex flex-row items-center">
                {appConfig?.modules?.logoPlaceHolder ? (
                  <>
                    <img
                      alt="logo"
                      src={appConfig?.assets?.imgs?.logoExt}
                      className="w-full h-full"
                    />
                  </>
                ) : (
                  <img
                    alt="logo"
                    className="w-full h-full"
                    src={studio.logoImageURL}
                  />
                )}
              </div>

              <IconButton
                className=""
                disableRipple
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <CustomArrowIcon className="w-6 h-6" />
                ) : (
                  <CustomMenuIcon className="w-8 h-8" />
                )}
              </IconButton>
            </div>
          ) : (
            <div>
              <IconButton onClick={() => setOpen(!open)} disableRipple>
                {open ? (
                  <CustomArrowIcon className="w-6 h-6" />
                ) : (
                  <CustomMenuIcon className="w-8 h-8" />
                )}
              </IconButton>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div
          className={`bg-background w-full flex flex-row items-center ${
            open ? "justify-end" : "justify-center"
          }`}
        >
          {open ? (
            <div className="flex flex-row w-full  items-center justify-between py-4 px-2">
              <div className="h-12 flex flex-row items-center">
                <img
                  alt="logo"
                  className="w-full h-full"
                  src={appConfig?.assets?.imgs?.logoExt}
                />
              </div>
              <IconButton
                className=""
                disableRipple
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <CustomArrowIcon className="w-6 h-6" />
                ) : (
                  <CustomMenuIcon className="w-8 h-8" />
                )}
              </IconButton>
            </div>
          ) : (
            <div>
              <IconButton onClick={() => setOpen(!open)} disableRipple>
                {open ? (
                  <CustomArrowIcon className="w-6 h-6" />
                ) : (
                  <CustomMenuIcon className="w-8 h-8" />
                )}
              </IconButton>
            </div>
          )}
        </div>
      );
    }
  };

  return (
    <CustomDrawer variant="permanent" open={open} className="bg-background">
      <DrawerHeader className="bg-background items-center">
        {returnLogoStudio()}
      </DrawerHeader>
      <List
        className="bg-background h-full w-full"
        sx={{ overflowX: "hidden" }}
      >
        {routes
          .filter((route) => route.isSidebarElement)
          .sort((a, b) => a.order - b.order)
          .map((route) => {
            const lastPathSegment = location.pathname.split("/").pop();
            return (
              <ListItem
                selected={selectedRoute === route.path}
                className={`text-black font-semibold ${
                  lastPathSegment === route.path ? "bg-grey/70" : ""
                }`}
                key={route.path}
                button
                onClick={() => {
                  navigate(route.path);
                  setSelectedRoute(route.path);
                }}
              >
                <ListItemIcon>{route.icon}</ListItemIcon>
                <p primary={route.label} className="text-black font-bold">
                  {route.label}
                  {route.ai && (
                    <>
                      {" "}
                      <CoreIAicon />
                    </>
                  )}
                </p>
              </ListItem>
            );
          })}
      </List>
    </CustomDrawer>
  );
};

export default Sidebar;
